import { useTranslation } from "react-i18next";

const WinePairing = ({ wineGeneralRecommendation, winePairing }) => {
  const { t } = useTranslation();

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";

  const renderRichText = (blocks) => {
    return blocks.map((block, index) => {
      if (block.type === "paragraph") {
        return (
          <p key={index} className="text-dark lead" style={{ lineHeight: "100%" }}>
            {block.children?.map((child, idx) => (
              <span key={idx}>{child.text}</span>
            ))}
          </p>
        );
      }
      return null;
    });
  };

  return (
    <div className="container mt-10">
      <div className="row justify-content-center">
        <div className="col-12">
          <h2 className="mb-2 text-black">{t("recipe.winePairing", "Wine pairing")}</h2>

          {/* Render general wine recommendation (rich text) */}
          {Array.isArray(wineGeneralRecommendation) && (
            <div className="mb-4">
              {renderRichText(wineGeneralRecommendation)}
            </div>
          )}

          {/* Render each wine pairing */}
          {Array.isArray(winePairing) && winePairing.length > 0 && (
			  
			<ol className="list-group list-group-separated col-12">
            {winePairing
              .map((item, idx) => (
                <li
                  key={idx}
                  className="list-group-item d-flex justify-content-between align-items-start text-black"
                >
                  <span className="">
                    <p className="lead" style={{ lineHeight: "100%" }}>
			  		<span style={{ lineHeight: "100%", fontWeight:"bold", textTransform:"uppercase" }}>
			  			{item.name} ({item.region}{item.country ? `, ${item.country}` : ""})<br />
					</span>
		
					{item.typeAndGrapes}<br />
					{item.tastingNotes} {item.extraNotes}
					</p>
                  </span>
                </li>
              ))}
          </ol>

          )}
        </div>
      </div>
    </div>
  );
};

export default WinePairing;
